export default __webpack_public_path__ + "static/media/lydian-watermark.e2446ee9.png";